import axios from 'axios';
import { useState ,useEffect} from 'react';
import './App.css';
import { useAuthMutation } from './hooks/useAuthMutation';
import { useAddRefMutation } from './hooks/useAddRefMutation';
import { GoogleLogin } from '@react-oauth/google';
function App() {
  const [isLoggedIn,setIsLoggedIn]=useState(false)
  const [myRef,setMyRef]=useState("")
  const {mutate,error,data,isError}=useAuthMutation()
  const {mutate:AddRefMutate,error:AddRefError,data:AddRefData,isError:AddRefIsError,isSuccess}=useAddRefMutation()


useEffect(()=>{
  const queryParams = new URLSearchParams(window.location.search);
  const ref = queryParams.get('ref')
  if(ref){
 
    setMyRef(ref)
    sessionStorage.setItem('userId',myRef)
  }else{
   
  }
 
},[])

useEffect(()=>{
if(data){
  const email = sessionStorage.getItem('email')

  AddRefMutate({
    userId:myRef,
    refEmail:email
  })
 
  window.location.href='https://chromewebstore.google.com/detail/jdjcifgkfajhdagndfmlhdmhimhicddc?hl=en&authuser=0'
}
},[data])
  const signUpWithGoogle=(googleData)=>{
    const token = googleData.credential
 
    mutate({
      credit:10,
      token,
      
    })
   
  
 
  
    
 
  

  }


if(AddRefIsError){
  console.log(AddRefError,'AddRefError')
}

if(isError){
  console.log(error,'error!!!!')
}
  return (
    <div className="App">
      <h1>
        <img className='onnoIcon' src='../48.png'/>
        ONNO.AI
      </h1>
      <div className='des'>
        <ol >
<li>Sign in to your Google account.</li>
<li>Navigate automatically to the Chrome Extension Web Store, then click the "Add to Chrome" button.</li>
<li>Go to YouTube and select the video you wish to watch.</li>
<li>After entering the video page, click on the "Summarize Video" button located on the right side.</li>
<li>If you wish to change the language, click on the settings icon.</li>
<li>Change the language by selecting your preferred option.</li>
<li>Refresh the page of the video you want to summarize.</li>
<li>Click on the "Summarize Video" button again, and a summary in your chosen language will be provided.</li>
        </ol>
      </div>
     

      <GoogleLogin
  onSuccess={signUpWithGoogle}
  size='large'
  shape='pill'
  theme='outline'
 
  logo_alignment='center'
  width={405}
  onError={() => {
    console.log('Login Failed');
  }}
/>

    </div>
  );
}

export default App;
